import React from "react"
import PropTypes from "prop-types"
import styled, { css } from "styled-components"
import { Link } from "gatsby"
import { breakpoints } from "../../../theme"
import { buttonStyle, Avatar } from "@bw/bits"

const TeaserStyle = css`
  text-decoration: none;
  width: 100%;
  display: block;
  color: currentColor;
  cursor: pointer;
  position: relative;
`

const StyledLink = styled(Link)`
  ${TeaserStyle}
`
const StyledA = styled.a`
  ${TeaserStyle}
`
const StyledDiv = styled.div`
  ${TeaserStyle}
`

const Background = styled.div`
  background: var(--primary);
  position: relative;
  width: 100%;
`

const TeaserWrapper = styled.div`
  height: 100%;
  position: relative;
`

const Small = styled.div`
  font-size: 12px;
  line-height: 165%;

  @media (min-width: ${breakpoints.medium}px) {
    font-size: 12px;
  }
`

const Title = styled.h3`
  font-weight: 700;
  font-size: 20px;
  margin: 0.3em 0 0.6em 0;

  &:first-child {
    margin-top: 0;
  }
`

const Excerpt = styled.div`
  display: none;
  font-size: 14px;
  line-height: 165%;

  @media (min-width: ${breakpoints.medium}px) {
    display: block;
    margin-top: 0.8em;
  }
`

const TeaserBody = styled.div`
  margin-top: 10px;
  .avatar {
    margin-top: 5px;
  }
`

const TopMargin = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 30px;
  display: flex;
  font-weight: bold;
  font-size: 13px;
  color: white;
  align-items: start;
  padding: 20px 20px 0 20px;

  a {
    color: var(--hero-color);
  }
`

const Button = styled.div`
  ${buttonStyle}
  margin: 25px 0 0 0;
`
const Image = styled.div`
  > * {
    width: 100%;
  }
`
const Category = styled.div`
  padding: 5px 15px;
  border-radius: 38px;
  background-color: ${props => props.categoryColor};
`

const Teaser = ({
  suptitle,
  title,
  excerpt,
  to,
  href,
  onClick,
  image,
  category,
  categoryColor,
  buttonLabel,
  author,
}) => {
  const Card = () => (
    <TeaserWrapper>
      <Background>
        <Image>{image}</Image>
        <TopMargin>
          <Category categoryColor={categoryColor}>{category}</Category>
        </TopMargin>
      </Background>
      <TeaserBody>
        {suptitle && <Small>{suptitle}</Small>}
        {title && <Title>{title}</Title>}
        {excerpt && <Excerpt>{excerpt}</Excerpt>}
        {buttonLabel && (
          <Button $fill $primary>
            {buttonLabel}
          </Button>
        )}
        {author && <Avatar name={author.name} image={author.image} />}
      </TeaserBody>
    </TeaserWrapper>
  )

  switch (true) {
    case to !== null:
      return (
        <StyledLink to={to}>
          <Card />
        </StyledLink>
      )

    case href !== null:
      return (
        <StyledA href={href} target="_blank">
          <Card />
        </StyledA>
      )

    case onClick !== null:
      return (
        <StyledDiv onClick={onClick}>
          <Card />
        </StyledDiv>
      )

    default:
      throw new Error(
        "Unsupported type of teaser. Should use one of these props: to, href or onClick"
      )
  }
}

export { Teaser }

Teaser.propTypes = {
  image: PropTypes.element,
  suptitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  excerpt: PropTypes.string,
  buttonLabel: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  to: PropTypes.string,
  category: PropTypes.string,
  categoryColor: PropTypes.string,
  sideContent: PropTypes.string,
  author: PropTypes.shape({
    name: PropTypes.string,
    image: PropTypes.any,
  }),
}
